import { Card, Col, Row } from "react-bootstrap";

function Support() {
    return (
        <Card>
            <Card.Body>
                <Row className=" w-100 ">
                    <Col xl={2} xs={3} className="p-1 d-sm-none d-md-block text-center">
                        <img
                            className="h-75 w-75 mt-2"
                            src="img/logo.png"
                        />
                    </Col>
                    <Col xl={3}></Col>
                    <Col className="mt-3"><strong>Support</strong></Col>
                </Row>
                <Row className="mt-2">
                    <Col>
                        <div className="text-center ps-0" style={{ fontFamily: 'Arial, sans-serif', lineHeight: '1.6' }}>

                            <strong> Contact MoneyPlant</strong>
                            <p> &nbsp;&nbsp;
                            We are providing 24x7 support.
                            </p>

                            <strong> Contact details</strong> <br />
                            Email : support.mplant@gmail.com <br />
                            Phone: +91 7490009086
                            
                        </div>
                    </Col></Row>
            </Card.Body>
        </Card>
    );
}
export default Support;